// For common reference throughout the app
import basePath from './basePath'

const timeInBasePath = basePath.timeIn
const timeInRoute = `/${timeInBasePath}`

const day6Route = `/${basePath.day6}`

const characterPathRx = new RegExp(`^${day6Route}\\b`)
const characterMainPathRx = new RegExp(`^${day6Route}/?$`)
const characterOpenPathRx = new RegExp(`^${day6Route}/open/([^/]+)$`)

const isNestedPath = (route, basePath) => route.path.startsWith(`/${basePath}/`)

export default {
  quickytools: {
    credits: 'quickytools-credits'
  },
  agreement: {
    terms: '/terms',
    privacy: '/privacy'
  },
  account: {
    login: '/login',
    register: '/register',
    isAuthRoute: path => /^\/\b(?:login|register)\b/i.test(path),
    isUnauthenticatedRoute: path => !/^\/(?:account|redeem-pass)/i.test(path),
    resetPassword: '/reset-password',
    home: '/account',
    communityAuth: '/account/community-auth'
  },
  timeIn: {
    isNestedPath: route => isNestedPath(route, timeInBasePath),
    new: `${timeInRoute}/new`,
    getDetailPath: timeId => `${timeInRoute}/detail/${timeId}`
  },
  day6: {
    isNestedPath: route => isNestedPath(route, basePath.day6),
    main: day6Route,
    openCharacterRoute: (shareId, query) => `${day6Route}/open/${shareId}?${query || ''}`,
    isCharacterPath: path => characterPathRx.test(path),
    isCharacterMainPath: path => characterMainPathRx.test(path),
    isCharacterOpenPath: path => characterOpenPathRx.test(path),
    getCharacterOpenDimensionsId: path => {
      const match = characterOpenPathRx.exec(path)
      return match ? match[1] : ''
    },
    navigateToCharacter: ($router, dimensionsId) => {
      // Compare location path not route path as location path updates on browser navigation. Requires location be up to date with loaded character.
      if (dimensionsId) {
        if (window.location.pathname !== `${day6Route}/open/${dimensionsId}`) {
          $router.push({ name: 'day6-open', params: { id: dimensionsId } })
        }
      } else {
        if (!characterMainPathRx.test(window.location.pathname)) {
          $router.push({ name: 'day6-main' })
        }
      }
    },
    isShareOpen: $route => $route && $route.name === 'day6-open',
    linkToExisting: (id, shareCount) => {
      const url = new URL(document.URL)

      if (id) {
        // More than 999 shares doesn't matter in analytics any more.
        if (typeof shareCount === 'number' && shareCount > 0 && shareCount < 999) {
          url.search = new URLSearchParams({ sc: shareCount })
        }
        url.pathname = `${basePath.day6}/open/${id}`
      } else {
        url.pathname = basePath.day6
      }
      return url.toString()
    }
  }
}
